export default "__VITE_ASSET__FBmlqcsx__"